// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ca9b9f76","42":"9c957e7e","283":"dd7d8dea","369":"6f006f2a","453":"be4a2963","571":"3921363b","768":"e0611806"}[chunkId] + ".chunk.js";
};